import { render } from "./ListField.vue?vue&type=template&id=06e596b0&scoped=true&ts=true"
import script from "./ListField.vue?vue&type=script&lang=ts"
export * from "./ListField.vue?vue&type=script&lang=ts"

import "./ListField.vue?vue&type=style&index=0&id=06e596b0&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e596b0"]])

export default __exports__